// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import { SummaryUtils_CheckoutConfigOptionGroupFragmentDoc } from '../../utils/summary.utils.generated';
import { FloorPlanOptionGroup_CheckoutOptionGroupFragmentDoc } from '../../components/organisms/FloorPlan.generated';
import { ConfiguratorContext_ProgramDataFragmentDoc, CommonFragment_FloorPlanAssetFragmentDoc } from '../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SummaryPrintConfigurationQueryVariables = Types.Exact<{
  checkoutConfigId: Types.Scalars['ID'];
}>;


export type SummaryPrintConfigurationQuery = { __typename?: 'Query', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, status: Types.CheckoutConfigStatus, createdAt: Types.Scalars['DateTime']['input'], reservedAt?: Types.Scalars['DateTime']['input'] | null | undefined, expiresAt?: Types.Scalars['Date']['input'] | null | undefined, customerEmail?: string | null | undefined, salesPriceInCents: number, totalPriceInCents: number, isReversed: boolean, rendering?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, name: string, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, totalPriceInCents: number, salesPriceInCents?: number | null | undefined } | null | undefined, floorPlanAssets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }> } | null | undefined, community: { __typename?: 'Community', id: string }, optionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, isEnabled: boolean, interiorSubStep?: { __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, stepNumber: number } | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, isSelected: boolean, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } }>, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined }>, programData?: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined } | null | undefined, insideMapsRoomRenderings: Array<{ __typename?: 'InsideMapsRoomRendering', id: string, asset?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined, readyPlanLocation: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, name: string } } }>, interiorSubSteps: Array<{ __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, location?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string } } | null | undefined }> } };

export type SummaryPrintConfiguration_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, status: Types.CheckoutConfigStatus, createdAt: Types.Scalars['DateTime']['input'], reservedAt?: Types.Scalars['DateTime']['input'] | null | undefined, expiresAt?: Types.Scalars['Date']['input'] | null | undefined, customerEmail?: string | null | undefined, salesPriceInCents: number, totalPriceInCents: number, isReversed: boolean, rendering?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, name: string, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, totalPriceInCents: number, salesPriceInCents?: number | null | undefined } | null | undefined, floorPlanAssets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }> } | null | undefined, community: { __typename?: 'Community', id: string }, optionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, isEnabled: boolean, interiorSubStep?: { __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, stepNumber: number } | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, isSelected: boolean, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } }>, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined }>, programData?: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined } | null | undefined, insideMapsRoomRenderings: Array<{ __typename?: 'InsideMapsRoomRendering', id: string, asset?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined, readyPlanLocation: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, name: string } } }>, interiorSubSteps: Array<{ __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, location?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string } } | null | undefined }> };

export type SummaryPrintConfiguration_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, name: string, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, totalPriceInCents: number, salesPriceInCents?: number | null | undefined } | null | undefined, floorPlanAssets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }> };

export type SummaryPrintConfiguration_InteriorRenderingFragment = { __typename?: 'InteriorRoomRendering', roomName: string, interiorScheme: string, asset?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined };

export type SummaryPrintConfiguration_InsideMapsRoomRenderingFragment = { __typename?: 'InsideMapsRoomRendering', id: string, asset?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined } | null | undefined, readyPlanLocation: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, name: string } } };

export type SummaryPrintConfiguration_AssetFragment = { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined };

export type SummaryPrintConfiguration_CheckoutConfigInteriorSubStepFragment = { __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, location?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string } } | null | undefined };

export const SummaryPrintConfiguration_AssetFragmentDoc = gql`
    fragment SummaryPrintConfiguration_Asset on Asset {
  id
  contentType
  largePreview: previewUrl(resizing: {width: 2500, region: FULL})
}
    `;
export const SummaryPrintConfiguration_ProductOfferingFragmentDoc = gql`
    fragment SummaryPrintConfiguration_ProductOffering on ProductOffering {
  id
  name
  baseConfig {
    id
    totalPriceInCents
    salesPriceInCents
  }
  floorPlanAssets {
    ...CommonFragment_FloorPlanAsset
  }
}
    ${CommonFragment_FloorPlanAssetFragmentDoc}`;
export const SummaryPrintConfiguration_InsideMapsRoomRenderingFragmentDoc = gql`
    fragment SummaryPrintConfiguration_InsideMapsRoomRendering on InsideMapsRoomRendering {
  id
  asset {
    ...SummaryPrintConfiguration_Asset
  }
  readyPlanLocation {
    id
    location {
      id
      name
    }
  }
}
    ${SummaryPrintConfiguration_AssetFragmentDoc}`;
export const SummaryPrintConfiguration_CheckoutConfigInteriorSubStepFragmentDoc = gql`
    fragment SummaryPrintConfiguration_CheckoutConfigInteriorSubStep on CheckoutConfigInteriorSubStep {
  id
  location {
    id
    location {
      id
    }
  }
  displayName
}
    `;
export const SummaryPrintConfiguration_CheckoutConfigFragmentDoc = gql`
    fragment SummaryPrintConfiguration_CheckoutConfig on CheckoutConfig {
  id
  name
  status
  createdAt
  reservedAt
  expiresAt
  customerEmail
  salesPriceInCents
  totalPriceInCents
  isReversed
  rendering {
    ...SummaryPrintConfiguration_Asset
  }
  productOffering {
    ...SummaryPrintConfiguration_ProductOffering
  }
  community {
    id
  }
  optionGroups {
    ...SummaryUtils_CheckoutConfigOptionGroup
    ...FloorPlanOptionGroup_CheckoutOptionGroup
  }
  programData {
    ...ConfiguratorContext_ProgramData
  }
  insideMapsRoomRenderings {
    ...SummaryPrintConfiguration_InsideMapsRoomRendering
  }
  interiorSubSteps {
    ...SummaryPrintConfiguration_CheckoutConfigInteriorSubStep
  }
}
    ${SummaryPrintConfiguration_AssetFragmentDoc}
${SummaryPrintConfiguration_ProductOfferingFragmentDoc}
${SummaryUtils_CheckoutConfigOptionGroupFragmentDoc}
${FloorPlanOptionGroup_CheckoutOptionGroupFragmentDoc}
${ConfiguratorContext_ProgramDataFragmentDoc}
${SummaryPrintConfiguration_InsideMapsRoomRenderingFragmentDoc}
${SummaryPrintConfiguration_CheckoutConfigInteriorSubStepFragmentDoc}`;
export const SummaryPrintConfiguration_InteriorRenderingFragmentDoc = gql`
    fragment SummaryPrintConfiguration_InteriorRendering on InteriorRoomRendering {
  roomName
  interiorScheme
  asset {
    ...SummaryPrintConfiguration_Asset
  }
}
    ${SummaryPrintConfiguration_AssetFragmentDoc}`;
export const SummaryPrintConfigurationDocument = gql`
    query SummaryPrintConfiguration($checkoutConfigId: ID!) {
  checkoutConfig(id: $checkoutConfigId) {
    ...SummaryPrintConfiguration_CheckoutConfig
  }
}
    ${SummaryPrintConfiguration_CheckoutConfigFragmentDoc}`;

/**
 * __useSummaryPrintConfigurationQuery__
 *
 * To run a query within a React component, call `useSummaryPrintConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryPrintConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryPrintConfigurationQuery({
 *   variables: {
 *      checkoutConfigId: // value for 'checkoutConfigId'
 *   },
 * });
 */
export function useSummaryPrintConfigurationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>(SummaryPrintConfigurationDocument, options);
      }
export function useSummaryPrintConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>(SummaryPrintConfigurationDocument, options);
        }
export type SummaryPrintConfigurationQueryHookResult = ReturnType<typeof useSummaryPrintConfigurationQuery>;
export type SummaryPrintConfigurationLazyQueryHookResult = ReturnType<typeof useSummaryPrintConfigurationLazyQuery>;
export type SummaryPrintConfigurationQueryResult = Apollo.QueryResult<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>;